<template>

  <div v-if="user" style="height: 100%;">
    <div :style="'width: 100%; height: 100%; position: relative;'">
        <div class="rgcf-body">

            <div class="rgcf-contact-form" :style="'max-width: 700px;'">
                <div class="shadow p-6" style="background: #FFFFFF;">
                    <div class="pt-4">
                      <p class="mb-1 text-xs mb-4"><strong>
                        <span v-if="!$route.params.review_id">Connect your accounts to share on social media automatically.</span>
                        <span v-if="$route.params.review_id">Select which accounts you would like.</span>
                      </strong></p>

                      <div @click="AuthProvider('facebook')" class="auth-provider float-left mr-4 mb-4 cursor-pointer" style="position: relative;"
                        :class="((user.facebook) ? 'connected' : '')"
                      >
                        <div class="float-left">
                          <img src="@/assets/images/review-services/www.facebook.com.png" alt="" style="height: 36px;" v-bind:style="{ opacity: ((user && !user.facebook) ? 0.5 : 1) }">
                        </div>
                        <!-- <div class="bg-gray-300 text-gray-600 text-sm text-center py-1 rounded-b-sm">facebook</div> -->

                        <div v-if="user && user.facebook" class="float-left pl-1 text-center" style="font-size: 12px; padding-top: 6px;">
                            {{ user.facebook.name }}

                          <button v-if="!$route.params.review_id" class="bg-red-500 text-white inline-block rounded px-2 cursor-pointer ml-1" style="padding-top: 2px; position: absolute; top: 17px; right: 15px;" @click="removeSocialAccount('facebook')"><i class="fa fa-times text-red"></i></button>
                        </div>

                        <div v-if="user && !user.facebook" class="text-right" style="padding-top: 6px; padding-right: 2px;">
                          <button class="bg-blue-700 hover:bg-blue-600 text-white inline-block rounded px-2 cursor-pointer" style="padding-top: 2px; font-size: 12px;">Connect</button>
                        </div>

                      </div>

                      <div v-show="false" @click="AuthProvider('instagram')" class="auth-provider float-left mr-4 mb-4 cursor-pointer" style="position: relative;"
                          :class="((user.instagram) ? 'connected' : '')"
                        >
                        <div class="float-left">
                          <img src="@/assets/images/review-services/www.instagram.com.png" alt="" style="height: 36px;" v-bind:style="{ opacity: ((user && !user.instagram) ? 0.5 : 1) }">
                        </div>
                        <!-- <div class="bg-gray-300 text-gray-600 text-sm text-center py-1 rounded-b-sm">instagram</div> -->

                        <div v-if="user && user.instagram" class="float-left pl-1 text-center" style="font-size: 12px; padding-top: 6px;">
                          {{ user.instagram.name }}

                          <button v-if="!$route.params.review_id" class="bg-red-500 text-white inline-block rounded px-2 cursor-pointer ml-1" style="padding-top: 2px; position: absolute; top: 17px; right: 15px;" @click="removeSocialAccount('instagram')"><i class="fa fa-times text-red"></i></button>
                        </div>

                        <div v-if="user && !user.instagram" class="text-right" style="padding-top: 6px; padding-right: 2px;">
                          <button class="bg-indigo-700 hover:bg-indigo-600 text-white inline-block rounded px-2 cursor-pointer" style="padding-top: 2px; font-size: 12px;">Connect</button>
                        </div>

                      </div>

                      <div @click="AuthProvider('google')" class="auth-provider float-left mr-4 mb-4 cursor-pointer" style="position: relative;"
                        :class="((user.google) ? 'connected' : '')"
                      >
                        <div class="float-left">
                          <img src="@/assets/images/review-services/www.google.com.png" alt="" style="height: 36px;" v-bind:style="{ opacity: ((user && !user.google) ? 0.5 : 1) }">
                        </div>
                        <!-- <div class="bg-gray-300 text-gray-600 text-sm text-center py-1 rounded-b-sm">google</div> -->

                        <div v-if="user && user.google" class="float-left pl-1 text-center" style="font-size: 12px; padding-top: 6px;">
                          {{ user.google.name }}

                          <button v-if="!$route.params.review_id" class="bg-red-500 text-white inline-block rounded px-2 cursor-pointer ml-1" style="padding-top: 2px; position: absolute; top: 17px; right: 15px;" @click="removeSocialAccount('google')"><i class="fa fa-times text-red"></i></button>
                        </div>

                        <div v-if="user && !user.google" class="text-right" style="padding-top: 6px; padding-right: 2px;">
                          <button class="bg-red-500 hover:bg-red-400 text-white inline-block rounded px-2 cursor-pointer" style="padding-top: 2px; font-size: 12px;">Connect</button>
                        </div>

                      </div>

                      <div @click="AuthProvider('twitter')" class="auth-provider float-left mr-4 mb-4 cursor-pointer" style="position: relative;"
                        :class="((user.twitter) ? 'connected' : '')"
                      >
                        <div class="float-left">
                          <img src="@/assets/images/review-services/www.twitter.com.png" alt="" class="" style="height: 36px;" v-bind:style="{ opacity: ((user && !user.twitter) ? 0.5 : 1) }">
                        </div>
                        
                        <!-- <div class="bg-gray-300 text-gray-600 text-sm text-center py-1 rounded-b-sm">Twitter</div> -->

                        <div v-if="user && user.twitter" class="float-left pl-1 text-center" style="font-size: 12px; padding-top: 6px;">
                          {{ user.twitter.name }}
                          
                          <button v-if="!$route.params.review_id" class="bg-red-500 text-white inline-block rounded px-2 cursor-pointer ml-1" style="padding-top: 2px; position: absolute; top: 17px; right: 15px;" @click="removeSocialAccount('twitter')"><i class="fa fa-times text-red"></i></button>
                        </div>

                        <div v-if="user && !user.twitter" class="text-right" style="padding-top: 6px; padding-right: 2px;">
                          <button class="bg-blue-400 hover:bg-blue-300 text-white inline-block rounded px-2 cursor-pointer" style="padding-top: 2px; font-size: 12px;">Connect</button>
                        </div>

                      </div>

                      <br clear="all" /><br clear="all" />
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

import { VueEditor } from "vue2-editor";

export default {
  metaInfo () {
    return {
      title: "Connect Social Accounts | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    VueEditor
  },
  data () {
    return {

        user: null,

        facebook_pages_loaded: false,
        facebook_pages: [],
        gmb_listings_loaded: false,
        gmb_listings: false,
        instagram_profiles_loaded: false,
        instagram_profiles: [],
    }
  },
  computed: {
    ...mapState({

    })
  },
  methods: {

    removeSocialAccount(type) {
        let self = this
        this.$swal({
            title: "Are you sure?",
            text: "This will delete the account permanently!",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes',
            cancelButtonText: "No"
         }).then(function(result) {

            if (result.isConfirmed) {
              try {
                axios.delete(process.env.VUE_APP_API_ENDPOINT + '/me/delete-social-account/' + type, {
                  headers: {
                    'Authorization': 'Bearer ' + self.user.jwt_token
                  }
                })

              }catch(e){
                console.log(e)
              }

              self.user[type] = null;
            }

         });
      },
    
	getUser: async function() {
        let self = this;

        try {
          let response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/me/get-user-by-uuid?uuid=' + this.$route.params.uuid, {
          headers: {
            
          },
          })
          
            this.user = response.data.user
        }catch(e){
            console.log(e);
        }

        this.contactFormLoaded = true;
    },

    AuthProvider(provider) {

        if (this.user[provider])
        return;

        let self = this;

        if (provider == 'facebook') {
          this.window_open = this.popupCenter(process.env.VUE_APP_API_ENDPOINT + '/auth/'+provider + "?jwt=" + this.user.jwt_token + "&host=" + window.location.origin, 'window_open', 800, 900);
        }
        else {
          this.window_open = this.popupCenter('https://api.ravu.me/auth/'+provider + "?jwt=" + this.user.jwt_token + "&host=" + window.location.origin, 'window_open', 800, 900);
        }

        if (this.window_proc) {
          clearInterval(this.window_proc);
          this.window_proc = null;
        }

        this.window_proc = setInterval(function() {
        try {
            // console.log(self.window_open.location.pathname);
            if (self.window_open.location.pathname == "/social-login-done") {
            self.window_open.close();
            self.window_open = null;
            clearInterval(self.window_proc);
            self.window_proc = null;

            self.getUser();
            }
        }
        catch (e) {
            console.log(e);
        }
        }, 300);

        return;

    },

    popupCenter(url, title, w, h) {
        var left = (screen.width/2)-(w/2);
        var top = (screen.height/2)-(h/2);
        return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
    },
  },
  created() {
    this.getUser()
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Open+Sans&family=Source+Sans+Pro&family=Roboto&family=Lato&family=PT+Sans&family=EB+Garamond&family=Raleway&family=Ubuntu&family=Montserrat&family=Courgette');
  
  a {
      text-decoration: none !important;
  }

  #editor1 {
      height: 120px;
  }

  .rgcf-header {
      width: 100%;
      min-height: 80px;
      padding: 20px;
  }

  .rgcf-footer {
      /* margin-top: 30px; */
      width: 100%;
      min-height: 60px;
      background-color: #f5f5f5;
      padding: 20px;
  }

  .rgcf-footer-text {
      font-size: 15px;
  }

  .rgcf-business-name {
      font-size: 20px;
  }

  .rgcf-subtitle {
      padding-top: 10px;
      font-size: 14px;
  }

  .rgcf-body {
      /* background-color: #f5f5f5; */
      width: 100%;
      /* max-width: 1200px; */
      margin: auto;
      padding: 20px;
      min-height: calc(100% - 165px);
  }

  .rgcf-contact-form {
      width: 100%;
      max-width: 800px;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 40px;
  }

  .rgcf-confirmation-text {
      padding: 30px;
      text-align: center;
  }

  .rgcf-body .rgcf-logo {
      padding-top: 20px;
      padding-bottom: 10px;
      text-align: center;
  }

  .rgcf-body .rgcf-logo img {
      display: initial;
  }
</style>